import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';

interface TransportExpencesReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;


    filter: {
        // dZoneGroups: any;
        targetDates: Date[];
    };

    items: any[];
}

const state: TransportExpencesReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        // dZoneGroups: null,
        targetDates: [new Date(), new Date()],
    },

    items: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.month) {
        queryParams.month = moment(params.month).format('YYYY-MM-DD');
    }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<TransportExpencesReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.transport_facts_costs')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');

                    resolve(null);
                }));
            } else {
                resolve(null);
            }
        })
    },
};

export const mutations: MutationTree<TransportExpencesReportState> = {
    START_LOADING: (state) => {
        state.loading = true;
        state.loaded = false;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
      state.items = data.transport_expences.documents
    },
};

const getters = {
  totalData(state: TransportExpencesReportState) {
    const header: any = {
      income: 0,
      total_weight: 0,
      calc_costs: 0,
      fact_costs: 0,
      calc_costs_by_kg: 0,
      fact_costs_by_kg: 0,
    }
    state.items.map((item: any) => {
      header.income += parseFloat(item.income)
      header.total_weight += parseFloat(item.total_weight)
      header.calc_costs += parseFloat(item.calc_costs)
      header.fact_costs += parseFloat(item.fact_costs)
      header.calc_costs_by_kg = header.total_weight > 0 ? header.calc_costs / header.total_weight : 0
      header.fact_costs_by_kg = header.total_weight > 0 ? header.fact_costs / header.total_weight : 0
    })
    return header
  },
  exportData(state: TransportExpencesReportState) {
    const csvContent: any[] = [];
    const header = [
      'Доставка до города/региона',
      'Продажи, руб',
      'Продажи,кг',
      'Затраты транспортные+хранение, руб.',
      'Расчетные Затраты на кг за период,р/кг',
      // 'Расчетные Затраты предыдущий период, р/кг',
      'Фактические затраты транспортные+хранение, руб.',
      'Фактические затраты на кг за период,р/кг',
      // 'Отправленно с НСК Производства',
      // 'Расхождения с фактом отправки (кг)',
    ]

    state.items.map((item: any) => {
      const row: any[] = [];
      row.push(item.name)
      row.push(item.income)
      row.push(item.total_weight)
      row.push(item.calc_costs)
      row.push((item.total_weight > 0 ? item.calc_costs / item.total_weight : 0))
      row.push(item.fact_costs)
      row.push((item.total_weight > 0 ? item.fact_costs / item.total_weight : 0))
      csvContent.push(row)
    })
    return [
        header,
        ...csvContent
    ]
  }
};

export const STORE_KEY = '$_transport_expences_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
